import React from 'react';
import {Stack, Typography} from "@mui/material";

const PIRHeader = () => {

    return (
        <>
            <Stack direction={'row'} spacing={2} align={'center'} justifyContent={'space-between'}>
                <Typography variant={'h5'}>Priority Intelligence Requirements</Typography>
            </Stack>
        </>
    );
};

export default PIRHeader;
